module.exports = __webpack_public_path__ + "static/media/store-compare.207e0426.png";